import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Stepper, Step, Paper, Typography, StepButton } from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

// function getSteps() {
//     return [
//         'Mengisi kuesioner', 
//         // 'Menghitung rapor mutu tiga responden',
//         // 'Mengisi kuesioner untuk kepala sekolah',
//         'Menghitung rapor mutu sekolah',
//         'Verifikasi rapor mutu oleh Pengawas',
//         'Pakta Integritas Kepala Sekolah'
//     ];
// }

class Timeline extends Component {
    state = {
        error:0,
        activeStep: 0,
        routeParams: {
            tahun: localStorage.getItem('tahun'),
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            token: localStorage.getItem('jwt_token')
        }
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.getTimeline(this.state.routeParams).then((result)=>{
            // console.log(this.props.timeline);
            const array = this.props.timeline;
            for (let index = 0; index < array.length; index++) {
                const option = array[index];
                
                let jtid = option.jenis_timeline_id;
                let tgl = option.tanggal;

                switch (jtid) {
                    case 1:
                        if(tgl !== null){
                            this.props.setActiveStep(1);
                        }
                        break;
                    case 2:
                        if(tgl !== null){
                            this.props.setActiveStep(2);
                        }
                        break;
                    case 3:
                        if(tgl !== null){
                            this.props.setActiveStep(3);
                        }
                        break;
                    case 4:
                        // console.log(tgl);
                        if(tgl !== null){
                            // alert('tes');
                            this.props.setActiveStep(4);
                        }
                        break;
                    case 5:
                        if(tgl !== null){
                            this.props.setActiveStep(5);
                        }
                        break;
                    default:
                        this.props.setActiveStep(0);
                        break;
                }
            }
            // this.props.timeline.map((option)=>{

                
            // });

            // this.props.setActiveStep(4);
        });
    }

    onClickStep = (option) =>{
        if(option.jenis_timeline_id === 1){
            this.goTolink('/PerangkatKuesioner');
        }else if(option.jenis_timeline_id === 2){
            this.goTolink('/RaporMutu');
        }else if(option.jenis_timeline_id === 5){
            this.goTolink('/PaktaIntegritas');
        }
    }

    render()
    {
        // const {classes} = this.props;
        // const steps = getSteps();
        
        return (
            <Paper elevation={1} style={{overflowX:'auto'}}>
                <Stepper activeStep={this.props.active_step} alternativeLabel className="hilangDiMobile">
                    {this.props.timeline.map((option, key) => {
                        return (
                            <Step key={key}>
                            {/* <StepLabel>{option.nama}</StepLabel> */}
                            <StepButton
                                style={{minWidth:'125px'}}
                                optional={<Typography variant="caption">
                                    {option.jenis_timeline_id === 1 && this.props.active_step > 0 && <span>Dimulai dari tanggal </span>}
                                    {option.jenis_timeline_id === 2 && this.props.active_step > 1 && <span>Terakhir diperbarui tanggal </span>}
                                    {option.jenis_timeline_id === 3 && this.props.active_step > 2 && <span>Diverifikasi tanggal </span>}
                                    {option.jenis_timeline_id === 4 && this.props.active_step > 3 && <span>Dikonfirmasi tanggal </span>}
                                    {option.jenis_timeline_id === 5 && this.props.active_step > 4 && <span>Dikonfirmasi tanggal </span>}
                                    {option.tanggal && String(option.tanggal).substring(0,19)}
                                </Typography>}
                                onClick={()=>this.onClickStep(option)}
                            >
                                <Typography variant="body1">{option.nama}</Typography>
                            </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>
                <Stepper activeStep={this.props.active_step} orientation="vertical" className="hilangDiDesktop">
                    {this.props.timeline.map((option, key) => {
                        return (
                            <Step key={key}>
                                {/* <StepLabel>{option.nama}</StepLabel> */}
                                <StepButton
                                    style={{textAlign:'left'}}
                                    optional={<Typography variant="caption">
                                        {option.jenis_timeline_id === 1 && this.props.active_step > 0 && <span>Dimulai dari tanggal </span>}
                                        {option.jenis_timeline_id === 2 && this.props.active_step > 1 && <span>Terakhir diperbarui tanggal </span>}
                                        {option.jenis_timeline_id === 3 && this.props.active_step > 2 && <span>Diverifikasi tanggal </span>}
                                        {option.jenis_timeline_id === 4 && this.props.active_step > 3 && <span>Dikonfirmasi tanggal </span>}
                                        {option.jenis_timeline_id === 5 && this.props.active_step > 4 && <span>Dikonfirmasi tanggal </span>}
                                        {option.tanggal && String(option.tanggal).substring(0,19)}
                                    </Typography>}
                                    onClick={()=>this.onClickStep(option)}
                                >
                                    <Typography variant="body1">{option.nama}</Typography>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>
            </Paper>
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        getTimeline: Actions.getTimeline,
        setActiveStep: Actions.setActiveStep
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        timeline: RaporMutu.timeline,
        active_step: RaporMutu.active_step
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Timeline)));



// WEBPACK FOOTER //
// ./src/main/content/RaporMutu/Timeline.js